<template>
  <div id="appNavbar">
    <ServerError v-if="ServerError" />
    <v-navigation-drawer v-model="sideNav" fixed temporary>
      <v-list-item-content class="hidden-md-and-up">
        <v-list v-if="appLogin" dense>
          <v-list-item v-for="item in navItemsLogin" :key="item.name" link>
            <v-list-item-content>
              <router-link :to="item.route">
                <v-list-item-title style="color:#63028F;" class="text-uppercase">{{ item.name }}</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title @click="appLogout" style="color:#63028F;">LOGOUT</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-content>
    </v-navigation-drawer>
    <v-navigation-drawer class="hidden-md-and-up" v-model="sideNav2" fixed temporary right>
      <v-list-item-content>
        <v-list dense>
          <v-list-item>
            <v-list-item-content class="text-left">
              <v-list-item-title style="color:#000;">
                <span style="font-size:18px;font-weight:bold">Categories</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-for="(item,i) in categories" :key="i" prepend-icon="mdi-chevron-right">
            <template v-slot:activator>
              <v-list-item-title>
                <span
                  style="font-family:opensanssemibold;font-size:14px;color:#464646;"
                >{{item.name}}</span>
              </v-list-item-title>
            </template>
            <v-list-item
              sub-group
              v-for="(subitem, j) in item.subcategory"
              :key="j"
              @click="1"
              link
            >
              <v-list-item-action>
                <span
                  style="font-family:opensansregular;font-size:14px;color:#616161;"
                >{{subitem.name}}</span>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-list-item-content>
    </v-navigation-drawer>
    <v-app-bar app dark color="#63028F" dense flat height="50px">
      <v-app-bar-nav-icon class="hidden-md-and-up" @click.native="sideNav = !sideNav">
        <v-icon>mdi-format-align-center</v-icon>
      </v-app-bar-nav-icon>
      <v-app-bar-nav-icon class="hidden-md-and-down" :ripple="false">
        <v-icon>mdi-format-align-center</v-icon>
        <!-- <v-img src="./../../assets/logo.png" height="50px" contain></v-img> -->
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link :to="disabledNav?'#':'/'">
          <!-- <span class="pl-3 AppHeading">Webpeedika</span> -->
          <v-layout wrap justify-start>
            <v-flex xs1>
              <v-img src="./../../assets/logo.png" height="50px" contain></v-img>
            </v-flex>
            <v-flex xs3 align-self-center>
              <span class="pl-2 AppHeading">Webpeedika</span>
            </v-flex>
          </v-layout>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click.native="sideNav2 = !sideNav2">
        <v-icon>mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-items class="nav_item hidden-sm-and-down">
        <v-layout wrap>
          <!-- <v-flex pt-1 xs12 align-self-center hidden-lg-and-down>
            <v-text-field
              label="Search Essentials"
              type="search"
              color="#63028F"
              append-icon="mdi-magnify"
              style="width:40vw"
              dense
              light
              solo
            ></v-text-field>
          </v-flex>-->
          <v-flex pt-1 xs12 align-self-center hidden-xl-and-up>
            <v-form @submit.prevent="getSearch">
              <v-text-field
                label="Search Essentials"
                type="search"
                v-model="searchKey"
                color="#63028F"
                append-icon="mdi-magnify"
                style="width:25vw"
                dense
                light
                solo
              ></v-text-field>
            </v-form>
          </v-flex>
        </v-layout>
        <!-- <v-row justify-center></v-row> -->
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="isTypeSeller && appLogin " class="nav_item hidden-sm-and-down">
        <v-row justify-center>
          <v-btn
            text
            :ripple="false"
            color="white"
            style="font-family:opensansregular;font-size:14px"
            class="nav_item text-capitalize"
          >Help</v-btn>
        </v-row>

        <v-row justify-center>
          <v-btn
            text
            :ripple="false"
            color="white"
            style="font-family::opensansregular;font-size:14px"
            class="nav_item text-capitalize"
          >Settings</v-btn>
        </v-row>
        <v-row justify-center>
          <v-btn
            text
            :ripple="false"
            color="white"
            style="font-family::opensansregular;font-size:14px"
            class="nav_item text-capitalize"
          >
            <span style="color:white;padding-left:5px;">
              <v-img src="./../../assets/images/bell.png" contain height="21px"></v-img>
            </span>
          </v-btn>
        </v-row>
        <v-row v-if="appLogin" justify-center>
          <v-menu
            :close-on-content-click="false"
            :nudge-bottom="40"
            :nudge-right="0"
            transition="slide-y-transition"
            style="padding-top:40px;"
            bottom
            light
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text :ripple="false" color="white" class="nav_item">
                <v-layout wrap justify-center class="text-self-center">
                  <v-flex>
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-flex>
                </v-layout>
              </v-btn>
            </template>
            <v-card width="150">
              <v-layout pa-3>
                <v-flex>
                  <router-link to="/Profile">
                    <v-layout style="cursor:pointer;">
                      <v-flex text-left>
                        <span style="font-size:12px;color:black">Profile</span>
                      </v-flex>
                      <v-flex text-right>
                        <v-icon style="font-size:14px;">mdi-account</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>
                  <v-divider></v-divider>
                  <!-- <router-link to="/Settings">
                    <v-layout style="cursor:pointer;">
                      <v-flex text-left>
                        <span style="font-size:12px;color:black">Settings</span>
                      </v-flex>
                      <v-flex text-right>
                        <v-icon style="font-size:14px;">mdi-wrench</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>-->
                  <v-divider></v-divider>
                  <v-layout @click="appLogout" style="cursor:pointer;">
                    <v-flex text-left>
                      <span style="font-size:12px;">Sign Out</span>
                    </v-flex>
                    <v-flex text-right>
                      <v-icon style="font-size:14px;">mdi-logout</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-menu>
        </v-row>
      </v-toolbar-items>
      <v-toolbar-items v-else class="nav_item hidden-sm-and-down">
        <v-row justify="center">
          <v-menu
            :close-on-content-click="false"
            :close-on-click="true"
            :nudge-bottom="40"
            :nudge-right="50"
            transition="slide-y-transition"
            style="padding-top:40px;"
            bottom
            light
            v-model="pincodeMenu"
          >
            <template v-slot:activator="{ on }">
              <v-btn text :ripple="false" color="white" class="nav_item" v-on="on">
                <v-layout wrap justify-center>
                  <v-flex>
                    <v-icon>mdi-map-marker-outline</v-icon>
                  </v-flex>
                  <v-flex text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs12>
                        <span
                          style="font-family: robotoregular;font-size:10px"
                          class="text-capitalize"
                        >Deliver to</span>
                      </v-flex>
                      <v-flex xs12>
                        <span style="font-family: robotoregular;font-size:11px">{{appPincode}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-btn>
            </template>
            <v-card width="260">
              <v-layout wrap pa-3 justify-center>
                <v-flex xs12 text-left>
                  <span
                    style="font-family: robotoregular;font-size:10px,color:#707070"
                    class="px-1"
                  >Enter Pincode</span>
                </v-flex>
                <v-flex px-1 xs8>
                  <v-text-field
                    label="Pin Code"
                    color="#63028F"
                    type="number"
                    maxlength="6"
                    :rules="rules"
                    dense
                    light
                    solo
                    v-model="pincode"
                  ></v-text-field>
                </v-flex>
                <v-flex px-1 xs4>
                  <v-btn
                    block
                    dark
                    color="#63028F"
                    class="text-capitalize"
                    @click="setPincode"
                  >Submit</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-menu>
        </v-row>
        <v-row justify-center>
          <v-btn
            text
            :ripple="false"
            color="white"
            style="font-family:robotoregular;font-size:11px"
            class="nav_item text-capitalize"
            to="/MyOrders"
          >My orders</v-btn>
        </v-row>
        <v-row justify-center>
          <v-btn
            text
            :ripple="false"
            color="white"
            style="font-family:robotoregular;font-size:11px"
            class="nav_item text-capitalize"
            to="/Wishlist"
          >My wish list</v-btn>
        </v-row>
        <v-row v-if="appLogin" justify-center>
          <v-menu
            :close-on-content-click="false"
            :nudge-bottom="40"
            :nudge-right="0"
            transition="slide-y-transition"
            style="padding-top:40px;"
            bottom
            light
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text :ripple="false" color="white" :to=" appLogin ? '':'/Login'">
                <v-layout wrap justify-center class="text-self-center">
                  <v-flex>
                    <v-icon>mdi-account-circle</v-icon>
                  </v-flex>
                  <v-flex text-left>
                    <v-layout wrap justify-start>
                      <v-flex xs12>
                        <span
                          style="font-family: robotoregular;font-size:10px"
                          class="text-capitalize"
                        >Hello,</span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          style="font-family: robotoregular;font-size:11px"
                          class="text-capitalize"
                        >{{userName}}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-btn>
            </template>
            <v-card width="150">
              <v-layout pa-3>
                <v-flex>
                  <router-link to="/Profile">
                    <v-layout style="cursor:pointer;">
                      <v-flex text-left>
                        <span style="font-size:12px;color:black">Profile</span>
                      </v-flex>
                      <v-flex text-right>
                        <v-icon style="font-size:14px;">mdi-account</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>
                  <v-divider></v-divider>
                  <router-link to="/Settings">
                    <v-layout style="cursor:pointer;">
                      <v-flex text-left>
                        <span style="font-size:12px;color:black">Settings</span>
                      </v-flex>
                      <v-flex text-right>
                        <v-icon style="font-size:14px;">mdi-wrench</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>
                  <v-divider></v-divider>
                  <v-layout @click="appLogout" style="cursor:pointer;">
                    <v-flex text-left>
                      <span style="font-size:12px;">Sign Out</span>
                    </v-flex>
                    <v-flex text-right>
                      <v-icon style="font-size:14px;">mdi-logout</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-menu>
        </v-row>
        <v-row v-else justify-center>
          <v-btn text :ripple="false" color="white" class="nav_item btnstyle" to="/Login">
            <v-layout wrap justify-center class="text-self-center">
              <v-flex>
                <v-icon>mdi-account-circle</v-icon>
              </v-flex>
              <v-flex text-left>
                <v-layout wrap justify-start>
                  <v-flex xs12>
                    <span
                      style="font-family: robotoregular;font-size:10px"
                      class="text-capitalize"
                    >Hello,</span>
                  </v-flex>
                  <v-flex xs12>
                    <span
                      style="font-family: robotoregular;font-size:11px"
                      class="text-capitalize"
                    >Sign In</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-btn>
        </v-row>
        <v-row justify-center>
          <v-btn text :ripple="false" color="white" class="nav_item" to="/Cart">
            <v-icon>mdi-cart</v-icon>
            {{appCart}}
          </v-btn>
        </v-row>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>
<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      pincodeMenu: false,
      navItems: [
        { name: "HOME", route: "/", icon: "mdi-home" },
        { name: "Orders", route: "/MyOrders", icon: "mdi-note-text" },
        { name: "Wish List", route: "/Wishlist", icon: "mdi-login" },
        { name: "Login", route: "/Login", icon: "mdi-lead-pencil" },
        { name: "Cart", route: "/Cart", icon: "mdi-lead-pencil" },
      ],
      navItemsLogin: [
        { name: "HOME", route: "/", icon: "mdi-home" },
        { name: "Orders", route: "/MyOrders", icon: "mdi-note-text" },
        { name: "Wish List", route: "/Wishlist", icon: "mdi-login" },
        { name: "Profile", route: "/Profile", icon: "mdi-lead-pencil" },
        { name: "Settings", route: "/Settings", icon: "mdi-lead-pencil" },
        { name: "Cart", route: "/Cart", icon: "mdi-lead-pencil" },
      ],
      user: {},
      categories: [],
      sideNav: false,
      sideNav2: false,
      userName: null,
      profilePic: null,
      pincode: "686001",
      cartItems: 0,
      rules: [(v) => v.length == 6 || "Invalid Pincode"],
      disabledNav: true,
      // usertype:localStorage.getItem("userType")
      searchKey: null,
    };
  },
  computed: {
    appLogin() {
      if (store.state.isLoggedIn) {
        this.userData();
      }
      return store.state.isLoggedIn;
    },
    appCart() {
      if (store.state.cartItems == undefined) {
        return 0;
      } else {
        return store.state.cartItems;
      }
    },
    appPincode() {
      this.pincodeChanged();
      return store.state.pincode;
    },
    isTypeSeller() {
      return store.state.isSeller;
    },
  },
  beforeMount() {
    if(this.$route.name=='Search'){
      this.searchKey=this.$route.params.searchKey
    }
    if (!store.state.isLoggedIn) {
      if (localStorage.getItem("pincode") == null) {
        this.getLocation();
      }
    }
    this.getCategory();
  },
  methods: {
    getSearch() {
      this.$router.push("/Search/" + this.searchKey);
    },
    pincodeChanged() {
      this.pincode = store.state.pincode;
    },
    getLocation() {
      var vm = this;
      navigator.permissions
        .query({
          name: "geolocation",
        })
        .then((response) => {
          if (response.state == "denied" && !store.state.isLoggedIn) {
            localStorage.setItem("pincode", this.pincode);
            store.commit("changePincode", this.pincode);
            return;
          } else {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                };
                var latlng = pos.lat + "," + pos.lng;
                vm.getGeoLocation(latlng);
              });
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    getGeoLocation(latlng) {
      axios({
        method: "GET",
        url: "https://maps.googleapis.com/maps/api/geocode/json",
        params: {
          latlng: latlng,
          key: this.googleAPIKey,
        },
      })
        .then((response) => {
          var data = response.data.results;
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].address_components.length; j++) {
              if (data[i].address_components[j].types[0] == "postal_code") {
                this.pincode = data[i].address_components[j].long_name;
                localStorage.setItem(
                  "pincode",
                  data[i].address_components[j].long_name
                );
                store.commit(
                  "changePincode",
                  data[i].address_components[j].long_name
                );
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    appLogout() {
      store.commit("logoutUser", true);
    },
    userData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.user = response.data.data;
            this.userName = response.data.data.fullname;
            this.pincode = this.user.currentpincode;
            localStorage.setItem("pincode", this.user.currentpincode);
            store.commit("changePincode", this.user.currentpincode);
            store.commit("changeCart", response.data.count);
            if (response.data.data.type == "Seller") {
              store.commit("userType", true);
              if (response.data.data.status == "Pending") {
                this.disabledNav = true;
              } else {
                this.disabledNav = false;
              }
            } else if (response.data.data.type == "Client") {
              this.disabledNav = false;
              store.commit("userType", false);
            }
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/category/getlist",
      }).then((response) => {
        this.appLoading = false;
        this.categories = response.data.data;
      });
    },
    setPincode() {
      if (this.pincode.length != 6) return;
      this.pincodeMenu = false;
      if (store.state.isLoggedIn) {
        this.appLoading = true;
        axios({
          method: "GET",
          url: "/user/currentpincode",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params: {
            pincode: this.pincode,
          },
        }).then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            localStorage.setItem("pincode", this.pincode);
            store.commit("changePincode", this.pincode);
          }
        });
      } else {
        localStorage.setItem("pincode", this.pincode);
        store.commit("changePincode", this.pincode);
      }
    },
  },
};
</script>

<style>
@media only screen and (min-width: 960px) and (max-width: 1060px) {
  .AppHeading {
    font-size: 12px !important;
  }
}
.nav_item {
  margin-top: 5px;
  margin-right: 20px;
}
.AppHeading {
  color: white;
  font-family: madesaonara2;
  font-size: 25px;
  letter-spacing: 3px !important;
}
.v-btn:before {
  background-color: transparent !important;
}
</style>

